/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs */

const en_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert Surround ♪♪`)
};

const fr_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserer entourer ♪♪`)
};

const de_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surround einfügen ♪♪`)
};

const it_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci Surround ♪♪`)
};

const ru_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставить объемный звук ♪♪`)
};

const es_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar sonido envolvente ♪♪`)
};

const zh_cn2_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入环绕声♪♪`)
};

const ja_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サラウンドを挿入♪♪`)
};

const hi_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सराउंड साउंड डालें ♪♪`)
};

const pt_pt2_shortcut_keys_name_insert_surround_music_notes_double = /** @type {(inputs: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir som surround ♪♪`)
};

/**
* | output |
* | --- |
* | "Insert Surround ♪♪" |
*
* @param {Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_insert_surround_music_notes_double = /** @type {((inputs?: Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Insert_Surround_Music_Notes_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "de") return de_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "it") return it_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "es") return es_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_insert_surround_music_notes_double(inputs)
	return en_shortcut_keys_name_insert_surround_music_notes_double(inputs)
});